module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_5500_Active@1x-b2cce0d4a188de87f65490c674c9cd26.png";